
export default {
  props: {
    businessPartnerBanner: {
      type: Object,
      default: () => {
        return { text: String, image: Object, link: Object }
      },
    },
  },
  methods: {
    cleanButtonUrl(url) {
      if (!url) return '/'
      const qIdx = url.indexOf('?')
      if (qIdx === -1) return url + '/'
      const path = url.slice(0, qIdx)
      const params = new URLSearchParams(url.slice(qIdx + 1))
      ;['event', 'lead_type', 'page_type'].forEach((p) => params.delete(p))
      const qs = params.toString()
      const cleanPath = path.endsWith('/') ? path : path + '/'
      return qs ? cleanPath + '?' + qs : cleanPath
    },
    handleButtonClick(url) {
      if (!url || !this.$gtm) return
      const qIdx = url.indexOf('?')
      if (qIdx === -1) return
      const params = new URLSearchParams(url.slice(qIdx + 1))
      const eventName = params.get('event')
      if (!eventName) return
      const leadType = params.get('lead_type') || ''
      const pageType = params.get('page_type') || undefined
      if (eventName === 'lead_redirect') {
        this.$gtm.sendLeadRedirectEvent(leadType, pageType)
      }
    },
  },
}
